import { render, staticRenderFns } from "./LocaleInfo.vue?vue&type=template&id=77dd19eb&scoped=true"
import script from "./LocaleInfo.vue?vue&type=script&lang=js"
export * from "./LocaleInfo.vue?vue&type=script&lang=js"
import style0 from "./LocaleInfo.vue?vue&type=style&index=0&id=77dd19eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd19eb",
  null
  
)

export default component.exports